export class BaseComponentModel
{
    constructor()
    {
    }
}
